import usePaymentMethodsToRender from './usePaymentMethodsToRender'
export default usePaymentMethodsToRender
